/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferHistorySpoilerRequestV2 {
  /** Идентификатор объявления **/
  offerId?: TOfferHistorySpoilerRequestV2_OfferId;
  /** Идентификатор дома **/
  houseId?: TOfferHistorySpoilerRequestV2_HouseId;
  /** Площадь объекта **/
  totalArea?: TOfferHistorySpoilerRequestV2_TotalArea;
  /** Количество комнат **/
  roomsCount?: TOfferHistorySpoilerRequestV2_RoomsCount;
  /** Тип сделки **/
  dealType?: EDealType;
  /** Требуется ли отдать историю из соседних домов **/
  withNearby?: boolean;
}

export type TOfferHistorySpoilerRequestV2_OfferId = null | number;

export type TOfferHistorySpoilerRequestV2_HouseId = null | number;

export type TOfferHistorySpoilerRequestV2_TotalArea = null | number;

export type TOfferHistorySpoilerRequestV2_RoomsCount = null | ERoomsCount;

export enum ERoomsCount {
  /** Отдельная комната(покупка/аренда отдельной комнаты в квартире) **/
  'OnlyRoom' = 'onlyRoom',
  /** Студия **/
  'Studio' = 'studio',
  /** Одна комната **/
  'One' = 'one',
  /** Две комнаты **/
  'Two' = 'two',
  /** Три комнаты **/
  'Three' = 'three',
  /** Четыре комнаты **/
  'Four' = 'four',
  /** Пять комнат **/
  'Five' = 'five',
  /** Шесть и более комнат **/
  'SixPlus' = 'sixPlus',
}
export enum EDealType {
  /** Продажа **/
  'Sale' = 'sale',
  /** Аренда **/
  'Rent' = 'rent',
}
